import SectionHeading from "@/pages/home/components/SectionHeading";
import { classicFilms } from "@/mocks/home";

export default function ClassicSection() {
  return (
    <section id="classic" className="w-full py-14 md:py-20 bg-accent-50">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="经典老片"
          tone="accent"
          title="跨越数十年的老电影，值得反复重看"
          desc="按下年代从早到晚排一遍，能看到不同时期讲故事的方式。经典老片常有修复版，重温前先留意片长与版本差异。"
        />

        <div className="mt-10 relative">
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-accent-200 md:-translate-x-1/2" />
          <ol className="space-y-8">
            {classicFilms.map((film, index) => {
              const isRight = index % 2 === 1;
              return (
                <li key={film.id} className="relative md:grid md:grid-cols-2 md:gap-10">
                  <span className="hidden md:block absolute left-1/2 top-6 -translate-x-1/2 w-3 h-3 rounded-full bg-accent-500 ring-4 ring-accent-100" />
                  <span className="md:hidden absolute left-4 top-6 -translate-x-1/2 w-3 h-3 rounded-full bg-accent-500 ring-4 ring-accent-100" />

                  <div
                    className={`pl-10 md:pl-0 ${
                      isRight ? "md:order-2 md:pl-10" : "md:order-1 md:pr-10 md:text-right"
                    }`}
                  >
                    <div
                      className={`flex gap-4 rounded-lg border border-accent-200/70 bg-background-50 p-4 md:p-5 ${
                        isRight ? "" : "md:flex-row-reverse md:text-right"
                      }`}
                    >
                      <div className="w-20 sm:w-24 shrink-0 aspect-[2/3] rounded-md overflow-hidden bg-background-200">
                        <img
                          src={film.poster}
                          alt={`${film.title} 老片海报`}
                          title={`${film.title} 经典老片片单`}
                          className="w-full h-full object-cover object-top"
                        />
                      </div>
                      <div className="min-w-0 flex-1">
                        <span className="inline-flex items-center h-6 px-2 rounded-md bg-accent-100 text-[11px] font-label font-medium text-accent-800">
                          {film.era}
                        </span>
                        <h3 className="mt-2 font-heading text-base md:text-lg font-bold text-foreground-950">
                          {film.title}
                        </h3>
                        <div className="mt-1 flex flex-wrap items-center gap-x-2 text-xs text-foreground-500 font-label">
                          <span>{film.region}</span>
                          <span className="text-background-400">·</span>
                          <span>{film.year}</span>
                          <span className="text-background-400">·</span>
                          <span className="text-accent-700 font-semibold">
                            {film.rating} 分
                          </span>
                        </div>
                        <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed">
                          {film.summary}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className={isRight ? "md:order-1" : "md:order-2"} aria-hidden="true" />
                </li>
              );
            })}
          </ol>
        </div>
      </div>
    </section>
  );
}